import { AppService } from "./AppService";

export class CarriersService extends AppService {
  get data() {
    return this.store.state.carriers;
  }

  fetchCarrierTypes({ idAddress, idCart, countryIsoCode, country, onSuccess, onError } = {}) {
    this.store.dispatch("carriers/fetchCarrierTypes", {
      idAddress,
      idCart,
      countryIsoCode,
      country,
      onSuccess,
      onError,
    });
  }

  fetchCarriers({
    idAddress,
    idCart,
    countryIsoCode,
    carrierType,
    responseLevel,
    postcode,
    city,
    address1,
    country,
    ip,
    onSuccess,
    onError,
  } = {}) {
    this.store.dispatch("carriers/fetchCarriers", {
      idAddress,
      idCart,
      countryIsoCode,
      carrierType,
      responseLevel,
      postcode,
      city,
      address1,
      country,
      ip,
      onSuccess,
      onError,
    });
  }

  //Postcode=75008&City=Paris&Address1=123,%20Rue%20du%20Faubourg%20Saint-Honoré&Country=FR
  //IP=41.248.170.196

  async getCarriers({
    idAddress,
    idCart,
    countryIsoCode,
    languageIsoCode,
    currencyIsoCode,
    carrierType,
    responseLevel,
    postcode,
    city,
    address1,
    country,
    ip,
  }) {
    let url = `carrier?LanguageIsoCode=${languageIsoCode}`;

    if (idAddress) {
      url += `&IdAddress=${idAddress}`;
    }

    if (idCart) {
      url += `&IdCart=${idCart}`;
    }

    if (countryIsoCode) {
      url += `&CountryIsoCode=${countryIsoCode}`;
    }

    if (carrierType) {
      url += `&CarrierType=${carrierType}`;
    }

    if (currencyIsoCode) {
      url += `&CurrencyIsoCode=${currencyIsoCode}`;
    }

    if (responseLevel) {
      url += `&ResponseLevel=${responseLevel}`;
    }

    if (postcode) {
      url += `&Postcode=${postcode}`;
    }

    if (city) {
      url += `&City=${city}`;
    }

    if (address1) {
      url += `&Address1=${address1}`;
    }

    if (country) {
      url += `&Country=${country}`;
    } else if (countryIsoCode) {
      url += `&Country=${countryIsoCode}`;
    }

    if (ip) {
      url += `&IP=${ip}`;
    }

    const response = await this.http.API_AUTH.get(url);
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      throw new Error(`Unexpected status code: ${response.status}`);
    }
  }
}
